<template>
  <div v-loading.body="loading">
    <!-- 搜索区域 -->
    <div class="filter">
      <div class="filter-header">
        <div>查询搜索</div>
        <el-button
          type="text"
          style="margin-left: auto"
          :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          @click="toggleFilter"
        >
          {{ filterFold ? "展开筛选" : "收起筛选" }}
        </el-button>
      </div>

      <el-collapse-transition>
        <div v-show="!filterFold">
          <div class="filter-content">
            <el-form :inline="true" :model="searchForm" class="search-form">
              <el-form-item label="商家ID">
                <el-input
                  v-model="searchForm.merchantId"
                  placeholder="请输入"
                  clearable
                  @clear="handleIdClear"
                />
              </el-form-item>
              <el-form-item label="商家名称">
                <el-select
                  v-model="searchForm.merchantName"
                  filterable
                  placeholder="请输入商家名称"
                  :remote-method="debouncedFetchSupply"
                  remote
                  clearable
                  @clear="handleIdClear"
                >
                  <el-option
                    v-for="item in supplyOption"
                    :key="item.supply_id"
                    :label="item.supply_name"
                    :value="item.supply_name"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button type="success" @click="handleExport">导出</el-button>
                <el-button
                  type="primary"
                  :disabled="!hasSetMarginPermission"
                  @click="handleSetMargin"
                >
                  保证金调值设置
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <!-- 数据列表 -->
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column prop="merchantId" label="商家ID" align="center" />
      <el-table-column prop="merchantName" label="商家名称" align="center" />
      <el-table-column prop="totalAmount" label="总余额" align="center" />
      <el-table-column
        prop="marginValue"
        label="本月保证金阈值"
        align="center"
      />
      <el-table-column prop="frozenAmount" label="冻结中" align="center" />
      <el-table-column
        prop="availableAmount"
        label="可提现余额"
        align="center"
      />
      <el-table-column label="操作" align="center" width="120">
        <template #default="scope">
          <el-button type="text" @click="handleViewFlow(scope.row)">
            查看流水
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 保证金调值设置弹窗 -->
    <el-dialog
      title="保证金调值设置"
      :visible.sync="settingDialogVisible"
      width="60%"
      :before-close="handleSettingClose"
    >
      <template #title>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <span>{{ " " }}</span>
          <span>保证金调值设置</span>
          <el-button style="margin-right: 30px" @click="handleSettingLog">
            日志
          </el-button>
        </div>
      </template>

      <div v-for="(item, index) in settings" :key="index" class="setting-row">
        <el-form :model="item" :rules="settingRules" inline>
          <el-form-item label="上月总代采计划金额">
            <el-input-number
              v-model="item.min"
              controls-position="right"
              placeholder="最小值"
              :min="0"
              :max="item.max ? item.max - 1 : 9999999999"
              :precision="2"
              class="price-input"
              @change="validateMinMax(item)"
            />
            <span class="separator">-</span>
            <el-input-number
              v-model="item.max"
              controls-position="right"
              placeholder="最大值"
              :min="item.min ? item.min + 1 : 0"
              :max="9999999999"
              :precision="2"
              class="price-input"
              @change="validateMinMax(item)"
            />
          </el-form-item>

          <el-form-item label="保证金阈值" required>
            <el-input-number
              v-model="item.threshold"
              controls-position="right"
              :min="0"
              :max="9999999999"
              :precision="2"
              class="margin-value"
            />
            <span style="margin-left: 5px">元</span>
          </el-form-item>

          <el-button
            v-if="index !== 0"
            type="text"
            @click="deleteSettingRow(index)"
          >
            删除
          </el-button>
        </el-form>
      </div>

      <div class="setting-footer">
        <el-button
          type="primary"
          :disabled="settings.length >= 100"
          @click="addSettingRow"
        >
          + 添加设置
        </el-button>
      </div>

      <template #footer>
        <el-button @click="handleSettingClose">取消</el-button>
        <el-button type="primary" @click="handleSettingSave">保存</el-button>
      </template>
    </el-dialog>

    <!-- 保证金阈值设置日志 -->
    <el-dialog
      title="保证金阈值设置日志"
      :visible.sync="settingLogVisible"
      width="80%"
      append-to-body
    >
      <div class="log-container">
        <el-table
          v-loading="logLoading"
          :data="settingLogs"
          border
          height="450px"
        >
          <el-table-column
            prop="before"
            label="修改前"
            min-width="350"
            header-align="center"
            show-overflow-tooltip
          >
            <template #default="scope">
              <div v-html="scope.row.before" />
            </template>
          </el-table-column>
          <el-table-column
            prop="after"
            label="修改后"
            min-width="350"
            header-align="center"
            show-overflow-tooltip
          >
            <template #default="scope">
              <div v-html="scope.row.after" />
            </template>
          </el-table-column>
          <el-table-column
            prop="operator"
            label="操作人"
            width="120"
            align="center"
          />
          <el-table-column
            prop="operateTime"
            label="操作时间"
            width="180"
            align="center"
          />
        </el-table>

        <!-- 添加分页组件 -->
        <div class="pagination" style="margin-top: 20px; text-align: right">
          <el-pagination
            :current-page="logPage"
            :page-size="logPageSize"
            :total="logTotal"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleLogSizeChange"
            @current-change="handleLogCurrentChange"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postGetSupplyDepositList,
  postExportSupplyDepositList,
  postSetSupplyDepositThreshold,
  postGetSupplyDepositThreshold,
  postGetSupplyDepositThresholdLog,
} from "@/openapi/erp/supplyDeposit.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "MerchantMarginAccount",

  data() {
    return {
      loading: false,
      tableLoading: false,
      filterFold: false,
      supplyOption: [],
      searchForm: {
        merchantId: "",
        merchantName: "",
      },
      debouncedFetchSupply: null,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      totalAmount: "2000.00",
      frozenAmount: "100.00",
      availableAmount: "1900.00",
      hasSetMarginPermission: true,
      settingDialogVisible: false,
      settingLogVisible: false,
      settings: [
        {
          min: null,
          max: null,
          threshold: null,
        },
      ],
      settingRules: {
        threshold: [
          { required: true, message: "保证金阈值不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value === null || value === "") {
                callback(new Error("保证金阈值不能为空"));
              } else if (!/^\d{1,10}$/.test(value)) {
                callback(new Error("请输入不超过10位的自然数"));
              } else {
                callback();
              }
            },
          },
        ],
        price: {
          validator: (rule, value, callback) => {
            if (value !== null && value !== "" && !/^\d{1,10}$/.test(value)) {
              callback(new Error("请输入不超过10位的自然数"));
            } else {
              callback();
            }
          },
        },
      },
      merchantList: [],
      settingLogs: [],
      logLoading: false,
      logPage: 1,
      logPageSize: 10,
      logTotal: 0,
      originalSettings: [],
    };
  },

  created() {
    this.checkPermission();
    this.debouncedFetchSupply = this.debounce(this.fetchSupply, 1000);
    this.fetchData();
    this.fetchMerchantList();
  },

  methods: {
    // 防抖函数
    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },

    // 搜索商家
    fetchSupply(query) {
      if (typeof query === "string" && query.trim()) {
        this.$http
          .post("/erp/Common/selectSupply", { supply_name: query })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.supplyOption = res.data.data;
            }
          });
      }
    },

    toggleFilter() {
      this.filterFold = !this.filterFold;
    },

    async fetchData(showLoading = false) {
      if (showLoading) {
        this.loading = true;
      }
      this.tableLoading = true;
      try {
        const params = {
          supply_id: this.searchForm.merchantId || undefined,
          supply_name: this.searchForm.merchantName || undefined,
          page: String(this.page),
          page_size: String(this.pageSize),
        };

        const res = await postGetSupplyDepositList(params);
        if (res?.list) {
          // 处理列表数据
          this.tableData = res.list.map((item) => ({
            merchantId: item.supply_id,
            merchantName: item.supply_name,
            totalAmount: this.formatAmount(item.platform_security_amount),
            marginValue: this.formatAmount(item.transactions), // 如果字段不对请调整
            frozenAmount: this.formatAmount(item.frozen),
            availableAmount: this.formatAmount(item.withdrawable),
          }));

          this.total = res.total || 0;

          // 设置统计数据
          if (res.statistics) {
            this.totalAmount = this.formatAmount(res.statistics.total_amount);
            this.frozenAmount = this.formatAmount(res.statistics.total_frozen);
            this.availableAmount = this.formatAmount(
              res.statistics.total_withdrawable
            );
          }
        }
      } catch (error) {
        console.error(error);
        this.$message.error(error.message || "获取数据失败");
      } finally {
        this.loading = false;
        this.tableLoading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        merchantId: "",
        merchantName: "",
      };
      this.handleSearch();
    },

    // 导出
    async handleExport() {
      try {
        this.loading = true;
        // 添加搜索参数
        const params = {
          supply_id: this.searchForm.merchantId || undefined,
          supply_name: this.searchForm.merchantName || undefined,
        };

        const res = await postExportSupplyDepositList(params);
        if (res?.file) {
          window.open(apiBaseURL + res.file);
          this.$message.success("导出成功");
        } else {
          this.$message.error(res?.msg || "导出失败");
        }
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error(error.message || "导出失败");
      } finally {
        this.loading = false;
      }
    },

    // 检查权限
    async checkPermission() {
      try {
        // 调用权限检查接口
        const res = await this.checkUserPermission();
        this.hasSetMarginPermission = res.hasSetMarginPermission;
      } catch (error) {
        console.error("权限检查失败", error);
      }
    },

    // 保证金调值设置
    handleSetMargin() {
      if (!this.hasSetMarginPermission) {
        this.$message.error("请联系权限管理员开启权限");
        return;
      }
      this.settingDialogVisible = true;
      this.getMarginSettings();
    },

    // 获取当前保证金设置
    async getMarginSettings() {
      try {
        const res = await postGetSupplyDepositThreshold();
        console.log("原始返回数据:", res);
        if (res) {
          if (res.length) {
            const processedSettings = res.map((item) => {
              const processedItem = { ...item };

              // 如果min或max是空字符串，则设置为undefined以确保显示为空
              if (processedItem.min === "") {
                processedItem.min = undefined;
              }

              if (processedItem.max === "") {
                processedItem.max = undefined;
              }

              return processedItem;
            });
            this.settings = processedSettings;
            // 保存原始数据用于比较
            this.originalSettings = res.map((item) => ({
              min: !item.min ? "" : item.min,
              max: !item.max ? "" : item.max,
              threshold: Number(item.threshold),
            }));
          } else {
            this.settings = [
              { min: undefined, max: undefined, threshold: undefined },
            ];
            this.originalSettings = [{ min: "", max: "", threshold: null }];
          }
          console.log("处理后的设置数据:", this.settings);
        }
      } catch (error) {
        console.error("获取保证金设置失败", error);
        this.$message.error("获取保证金设置失败");
      }
    },

    addSettingRow() {
      if (this.settings.length >= 100) {
        this.$message.error("最多设置100项");
        return;
      }
      this.settings.push({
        min: undefined,
        max: undefined,
        threshold: undefined,
      });
    },

    deleteSettingRow(index) {
      this.settings.splice(index, 1);
    },

    handleSettingClose() {
      this.$confirm("确认退出编辑?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.settingDialogVisible = false;
          this.settings = [
            {
              min: null,
              max: null,
              threshold: null,
            },
          ];
        })
        .catch(() => {});
    },

    validateSettings() {
      // 检查保证金阈值是否为空
      const hasEmptyThresholds = this.settings.some(
        (setting) => !setting.threshold
      );
      if (hasEmptyThresholds) {
        this.$message.error("保证金阈值不能为空，请检查");
        return false;
      }

      // 多行设置时，检查区间交集
      for (let i = 0; i < this.settings.length; i++) {
        for (let j = i + 1; j < this.settings.length; j++) {
          const range1 = this.settings[i];
          const range2 = this.settings[j];

          // 将空的最小值视为0，将空的最大值视为9999999999
          const min1 = range1.min !== null ? Number(range1.min) : 0;
          const max1 = range1.max !== null ? Number(range1.max) : 9999999999;
          const min2 = range2.min !== null ? Number(range2.min) : 0;
          const max2 = range2.max !== null ? Number(range2.max) : 9999999999;

          if (!(max1 < min2 || max2 < min1)) {
            this.$message.error("计划金额区间之间有交集，请检查");
            return false;
          }
        }
      }

      // 多行设置时，检查数值格式和大小关系
      for (const setting of this.settings) {
        if (!/^\d{1,10}$/.test(setting.threshold)) {
          this.$message.error("保证金阈值必须为不超过10位的自然数");
          return false;
        }

        if (
          setting.min !== null &&
          setting.max !== null &&
          Number(setting.min) > Number(setting.max)
        ) {
          this.$message.error("计划金额区间最小值不能大于最大值");
          return false;
        }
      }

      return true;
    },

    async handleSettingSave() {
      if (!this.validateSettings()) return;

      try {
        // 对设置进行排序，按照最小值从小到大排序
        const sortedSettings = [...this.settings].sort((a, b) => {
          const minA = a.min === null ? 0 : Number(a.min);
          const minB = b.min === null ? 0 : Number(b.min);
          return minA - minB;
        });

        // 处理提交的数据，将null转换为空字符串
        const processedSettings = sortedSettings.map((setting) => ({
          min: !setting.min ? "" : setting.min,
          max: !setting.max ? "" : setting.max,
          threshold: Number(setting.threshold),
        }));

        // 检查数据是否有变化
        const currentSettingsStr = JSON.stringify(processedSettings);
        const originalSettingsStr = JSON.stringify(this.originalSettings); // 需要在获取设置时保存原始数据

        if (currentSettingsStr === originalSettingsStr) {
          this.$message.info("设置数据未变化，无需保存");
          return;
        }

        await this.$confirm("确认保存设置?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        const res = await postSetSupplyDepositThreshold({
          deposit_threshold_setting: JSON.stringify(processedSettings),
        });

        if (res) {
          this.$message.success("保存成功");
          this.settingDialogVisible = false;
          this.fetchData();
          // 更新原始数据
          this.originalSettings = processedSettings;
        } else {
          this.$message.error(res.msg || "保存失败");
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("保存设置失败", error);
          this.$message.error("保存设置失败");
        }
      }
    },

    async handleSettingLog() {
      this.settingLogVisible = true;
      this.fetchSettingLogs();
    },

    async fetchSettingLogs() {
      this.logLoading = true;
      try {
        const params = {
          page: this.logPage,
          page_size: this.logPageSize,
        };

        const res = await postGetSupplyDepositThresholdLog(params);
        console.log(res);
        if (res?.list) {
          this.settingLogs = res.list.map((log) => ({
            before: log.old_setting,
            after: log.new_setting,
            operator: log.operator_name,
            operateTime: log.create_date,
          }));
          this.logTotal = res.total || 0;
        }
      } catch (error) {
        console.error("获取设置日志失败", error);
        this.$message.error("获取设置日志失败");
      } finally {
        this.logLoading = false;
      }
    },

    handleLogSizeChange(val) {
      this.logPageSize = val;
      this.fetchSettingLogs();
    },

    handleLogCurrentChange(val) {
      this.logPage = val;
      this.fetchSettingLogs();
    },

    // 查看流水
    handleViewFlow(row) {
      this.$router.push({
        name: "MerchantMarginAccountFlowLog",
        query: {
          merchantId: row.merchantId,
          merchantName: row.merchantName,
        },
      });
    },

    handleIdClear() {
      this.fetchData();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },

    // 添加格式化金额的工具方法
    formatAmount(amount) {
      if (!amount && amount !== 0) return "0.00";
      return Number(amount).toFixed(2);
    },

    // 验证最小值和最大值
    validateMinMax(item) {
      if (item.min !== null && item.max !== null) {
        if (Number(item.min) >= Number(item.max)) {
          this.$message.warning("最小值必须小于最大值");
          this.$set(item, "max", Number(item.min) + 1);
        }
      }
    },

    // 获取商家列表
    async fetchMerchantList() {
      try {
        const res = await postGetSupplyDepositList({
          page: "1",
          page_size: "1000", // 获取足够多的商家列表用于筛选
        });

        if (res?.list) {
          this.merchantList = res.list.map((item) => ({
            id: item.supply_id,
            name: item.supply_name,
          }));
        }
      } catch (error) {
        console.error("获取商家列表失败", error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.filter {
  border: 1px solid #ddd;
  margin-bottom: 20px;

  .filter-header {
    background: #f3f3f3;
    height: 30px;
    line-height: 30px;
    padding: 0 25px;
    display: flex;
    align-items: center;
  }

  .filter-content {
    padding: 10px 25px;
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.el-table ::v-deep .cell {
  white-space: pre-line;
  line-height: 1.5;
}

.setting-row {
  margin-bottom: 20px;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.price-input {
  width: 120px;
}

.separator {
  margin: 0 10px;
}

.margin-value {
  width: 120px;
}

.setting-footer {
  margin-top: 20px;
  text-align: left;
}

.el-input-number {
  width: 160px;
}

.setting-row {
  .el-form {
    display: flex;
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
      margin-right: 20px;
    }
  }
}

.log-container {
  max-height: 550px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchantMarginAccount/index.vue